
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"90","height":"90","fill":"none"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M82.5 39.375v18.75c0 13.125-7.5 18.75-18.75 18.75h-37.5C15 76.875 7.5 71.25 7.5 58.125v-26.25c0-13.125 7.5-18.75 18.75-18.75H52.5","stroke":"#4789C6","stroke-width":"5","stroke-miterlimit":"10","stroke-linecap":"round","stroke-linejoin":"round"}}),_c('path',{attrs:{"d":"M26.25 33.75l11.737 9.375c3.863 3.075 10.2 3.075 14.063 0l4.425-3.525","stroke":"#4789C6","stroke-width":"5","stroke-miterlimit":"10","stroke-linecap":"round","stroke-linejoin":"round"}}),_c('path',{attrs:{"d":"M73.125 30a9.375 9.375 0 100-18.75 9.375 9.375 0 100 18.75z","stroke":"#70D788","stroke-width":"5","stroke-miterlimit":"10","stroke-linecap":"round","stroke-linejoin":"round"}})])
          )
        }
      }
    